/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import Splide from "@splidejs/splide";

// フロントエンドでのみSplideのCSSを読み込み
if (typeof window !== "undefined" && !window.wp?.editor) {
  import("@splidejs/splide/css/core");
}

document.addEventListener("DOMContentLoaded", function () {
  // スライダー要素が存在するかチェック
  const sliderElements = document.querySelectorAll(".slider.splide");

  if (sliderElements.length === 0) {
    return;
  }

  // 各スライダーを初期化
  sliderElements.forEach((element) => {
    const slide = new Splide(element, {
      arrows: true,
      pagination: false,
      perPage: 3,
      perMove: 1,
      gap: "16px",
      breakpoints: {
        768: {
          perPage: 2,
        },
        480: {
          perPage: 1,
        },
      },
    });

    slide.mount();
  });
});
